module.exports = __webpack_public_path__ + "static/media/teo-logov2-400px.04287a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teo-logov2-400px.png
// module id = 1864
// module chunks = 0